/* This file is autogenerated by @oui/cli */ function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Svg, { Path } from "react-native-svg";
var SvgComponent = function(props) {
    return /*#__PURE__*/ _jsxs(Svg, _object_spread_props(_object_spread({
        width: 18,
        height: 16,
        viewBox: "0 0 18 16",
        fill: "none"
    }, props), {
        children: [
            /*#__PURE__*/ _jsx(Path, {
                d: "M7.14 12.06c.45-.2.78-.5 1.12-.86l.53-.55c.36-.37.55-.56.95-.84.1-.04.12-.28.05-.37-.12-.13-.25-.17-.43-.23 0 0-.84-.07-1.36-.21-.95-.26-2.26-1.14-2.26-1.14-.56-.38-.55-.85-.23-1.4.38-.66 1.01-1 1.7-1.25a10 10 0 0 1 2.2-.53 8 8 0 0 1 1.67-.1 3 3 0 0 1 1.81.74q.9.77 1.14 1.9c.13.55.87 4.3.97 4.84",
                stroke: "currentColor",
                strokeWidth: 2,
                strokeLinecap: "round",
                strokeLinejoin: "round",
                vectorEffect: "non-scaling-stroke"
            }),
            /*#__PURE__*/ _jsx(Path, {
                d: "M1 12s0 .05.18.18c.28.2.63.29.96.41a36 36 0 0 0 10.08 2.22c.98.05 1.96.07 2.94-.02.34-.04.37-.08.87-.24l.72-.17",
                stroke: "currentColor",
                strokeWidth: 2,
                strokeLinecap: "round",
                strokeLinejoin: "round",
                vectorEffect: "non-scaling-stroke"
            }),
            /*#__PURE__*/ _jsx(Path, {
                d: "M1 11.83c.1-.3.36-.38.61-.49a7 7 0 0 1 2-.5q1-.11 2-.08c.36.02.74-.02 1.1.12",
                stroke: "currentColor",
                strokeWidth: 2,
                strokeLinecap: "round",
                strokeLinejoin: "round",
                vectorEffect: "non-scaling-stroke"
            }),
            /*#__PURE__*/ _jsx(Path, {
                d: "M10.4 7.89c.7.15 1.2.75 1.02 1.6q-.13.73-.2 1.48l-.15 1.05q-.04.42-.14.83",
                stroke: "currentColor",
                strokeWidth: 2,
                strokeLinecap: "round",
                strokeLinejoin: "round",
                vectorEffect: "non-scaling-stroke"
            }),
            /*#__PURE__*/ _jsx(Path, {
                d: "m12.5 11.5 2 1c1 .5 1.31.55 1.9.88.29.17.53.36.6.7",
                stroke: "currentColor",
                strokeWidth: 2,
                strokeLinecap: "round",
                strokeLinejoin: "round",
                vectorEffect: "non-scaling-stroke"
            }),
            /*#__PURE__*/ _jsx(Path, {
                d: "M15.2 2c.8.16 1.42.6 1.7 1.39.34.97-.18 2.14-1.32 2.5a1.9 1.9 0 0 1-2.05-.54c-.55-.6-.65-1.29-.4-2.05.3-.83 1.02-1.3 2.02-1.3",
                fill: "currentColor"
            })
        ]
    }));
};
export default SvgComponent;
